<template>
    <div>
        <v-layout row wrap justify-center align-center>
            <v-flex xs12 sm7 md7 >
                <h2>Cumprimentos</h2>
            </v-flex>
            <v-flex xs12 sm8 md8 mt-2 class="cont-texto">
                <p>
                    No mundo inteiro, quando duas pessoas se encontram, elas se cumprimentam. Japoneses fazem uma mesura, os americanos dão um aperto de mão, os russos se beijam na face.   Há muitos tipos de cumprimentos: o aperto de mão, o beijinho, o abraço, o tapinha nas costas.   No Brasil, os cumprimentos são, geralmente, muito afetuosos. Muitas vezes, os cumprimentos dos brasileiros chamam a atenção do estrangeiro. Quando duas pessoas são apresentadas, elas sempre se cumprimentam com um aperto de mão. Quando são mais amigas, elas substituem o aperto de mão pelo abraço ou o beijinho na face. O beijinho é um cumprimento informal entre duas mulheres, entre uma mulher e um homem, ou entre um adulto e uma criança.   O abraço expressa grande cordialidade e amizade. Geralmente, acontece entre dois homens. O brasileiro é muito informal e afetuoso. Quando ele fala com outra pessoa, fica fisicamente muito próximo dela. Para o brasileiro, é natural conversar com um amigo e colocar a mão nos ombros dele ou dar tapinhas nas costas. O contato físico faz parte do comportamento social do brasileiro.<br>
                </p>
                <p> <i>Adaptado de: Levy V, Amos E. / Prata da casa vida e cultura.</i> </p>
            </v-flex>
        </v-layout>        
    </div>
</template>

<script>
export default {
    data(){
        return {
            dialogosB:[
                'A gente cumprimenta assim:'
            ],
        }
    },
    methods: {
    },
}
</script>

<style lang="scss" scoped>
@import '../../../sass/globals';
.cont-texto{
    text-align: left;
}

</style>